<template>
  <!-- <div v-if="loadingState">loading...</div> -->
  <v-data-table
    :headers="headers"
    :items="items"
    sort-by="ID"
    :loading="loadingState"
    :search="search"
    multi-sort
    class="elevation-1"
    :footer-props="{
      showFirstLastPage: true,
      itemsPerPageText: 'Elemente pro Seite:',
      itemsPerPageAllText: 'Alle',
    }"
  >
    <template #[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} / {{ items.itemsLength }}
    </template>
    <template #top>
      <v-toolbar flat dense short>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suche"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" x-small fab @click="initialize">
          <v-icon medium>mdi-reload</v-icon>
        </v-btn>
        <v-divider vertical inset></v-divider>
        <v-dialog v-model="dialog" max-width="500px">
          <template #activator="{ on, attrs }">
            <v-btn color="primary" x-small fab v-bind="attrs" v-on="on">
              <v-icon medium>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span v-if="editedItem !== -1" class="headline">{{
                formTitle
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-switch v-model="editedItem.enabled" name="ja">
                      <template #label>
                        <span v-if="editedItem.enabled">Aktiviert</span>
                        <span v-else>Deaktiviert</span>
                      </template></v-switch
                    >
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.wknident"
                      label="WKNIdent"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-text-field
                          v-model="editedItem.urlshorthandle"
                          label="URLShortHandle"
                          v-on="on"
                        ></v-text-field></template
                      ><span
                        >Spezifische Kunden-URL (z.B. "mustergmbh" um
                        "FQDN/mustergmbh" erreichen zu können.)</span
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.name1"
                      label="Name1"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.name2"
                      label="Name2"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.zipcode"
                      label="PLZ"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.city"
                      label="Ort"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.street"
                      label="Straße"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.country"
                      label="Land"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Abbrechen</v-btn>
              <v-btn color="primary" text @click="save">Speichern</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template #[`item.enabled`]="{ item }">
      <v-switch v-model="item.enabled" disabled height="0px"></v-switch>
    </template>
    <template #[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
    <template #no-data>
      <v-btn color="primary" @click="initialize">Aktualisieren</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "CompaniesTable",
  data: () => ({
    name: "Firmen",
    search: "",
    dialog: false,
    headers: [
      { text: "ID", align: "start", value: "ID" },
      { text: "WKNIdent", value: "wknident" },
      { text: "Name1", value: "name1" },
      { text: "Name2", value: "name2" },
      { text: "URLShortHandle", value: "urlshorthandle" },
      { text: "Stadt", value: "city" },
      { text: "PLZ", value: "zipcode" },
      { text: "Straße", value: "street" },
      { text: "Land", value: "country" },
      { text: "Aktiviert", value: "enabled" },
      { text: "Aktionen", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {
      companyid: null,
      name: "",
      email: "",
    },
  }),
  computed: {
    ...mapGetters("companies", {
      loadingState: "loadingState",
      items: "items",
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Neu"
        : "Bearbeiten" + " | ID: " + this.editedItem.ID;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch("companies/updateData");
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      const index = this.items.indexOf(item);
      await Swal.fire({
        title: "Sicher, dass dieses Element gelöscht werden soll?",
        showDenyButton: true,
        confirmButtonText: `Löschen`,
        denyButtonText: `Abbrechen`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("companies/delete", item);
          this.items.splice(index, 1);
          Swal.fire("Gelöscht!", "", "success");
        } else if (result.isDenied) {
          Swal.fire("Das Element wurde nicht gelöscht.", "", "info");
          return true;
        }
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
        this.$store.dispatch("companies/update", this.editedItem);
      } else {
        this.$store.dispatch("companies/add", this.editedItem);
      }
      this.close();
    },
  },
};
</script>
